import { combineReducers } from 'redux';
import {
  HANDOFF,
  HANDOFF_BUSY,
  HANDOFF_ERROR,
  HANDOFF_MODAL_CLOSE,
  HANDOFF_SUCCESS,
  HANDOFF_TIMEOUT,
} from './constants';
import booleanReducer from '../common/reducers/booleanReducer';
import kioskSyncCart from '../kioskCartSync/reducer';

export const HANDOFF_STATUS = {
  ok: 'ok',
  busy: 'busy',
  error: 'error',
  timeout: 'timeout',
  pending: 'pending',
  initial: 'initial',
};

const status = (state = HANDOFF_STATUS.initial, { type }) => {
  switch (type) {
    case HANDOFF:
      return HANDOFF_STATUS.pending;
    case HANDOFF_BUSY:
      return HANDOFF_STATUS.busy;
    case HANDOFF_ERROR:
      return HANDOFF_STATUS.error;
    case HANDOFF_SUCCESS:
      return HANDOFF_STATUS.ok;
    case HANDOFF_TIMEOUT:
      return HANDOFF_STATUS.timeout;
    default:
      return state;
  }
};

const cart = (state = null, { type, payload }) => {
  switch (type) {
    case HANDOFF:
      return payload.cartId;
    case HANDOFF_SUCCESS:
    case HANDOFF_MODAL_CLOSE:
      return null;
    default:
      return state;
  }
};

const modal = booleanReducer(false, [HANDOFF], [HANDOFF_MODAL_CLOSE, HANDOFF_SUCCESS, HANDOFF_TIMEOUT]);

const reducer = combineReducers({
  status,
  cart,
  modal,
  kioskSyncCart, // this reducer belongs here in terms of store structure
});
export default reducer;
